module.exports = __webpack_public_path__ + "static/media/cookie.89553c13.svg";